import React, { Dispatch } from "react";
import { useSelector, useDispatch } from "react-redux";
import { get } from "lodash";
import { AlertInline } from "@tvg/design-system";
import { getHeaderMessage } from "@tvg/sh-lib-my-bets/redux/selectors";
import xSellBridge from "@tvg/sh-utils/xSellBridge";

export const closeMyBets = () => ({
  type: "MYBETS_CLOSE"
});

export const onHeaderMessageLinkClick = (
  type: string,
  dispatch: Dispatch<unknown>
) => {
  if (type === "OPEN_SPORTSBOOK_BETS") {
    xSellBridge.onTriggerSBMyBets();
    return;
  }
  dispatch(closeMyBets());
};

const AlertXsell = () => {
  const dispatch = useDispatch();
  const messageHeader = useSelector(getHeaderMessage);

  return (
    <AlertInline
      message={messageHeader.text}
      title={messageHeader.title}
      icon="info"
      qaLabel="xsell-message-inline"
      variant="informational"
      type="floating"
      mb={12}
      actionLink={
        <AlertInline.Link
          qaLabel="notification-sportsbook-message"
          onPress={() =>
            onHeaderMessageLinkClick(
              get(messageHeader, "link.type", ""),
              dispatch
            )
          }
        >
          {messageHeader.link?.text}
        </AlertInline.Link>
      }
    />
  );
};

export default AlertXsell;
